import { motion } from 'framer-motion';

const LOGO_URL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_48ccfe14-9a78-4511-9adb-e31d4f86bb3c/artifacts/qhjao7c6_ChatGPT%20Image%20Jul%2027%2C%202026%2C%2011_59_00%20PM.png';

export const PageHero = ({ kicker, title, description, testId }) => (
  <section className="relative bg-navy text-white pt-40 pb-24 px-6 sm:px-10 lg:px-16 overflow-hidden" data-testid={testId}>
    <div className="absolute -right-24 -top-24 w-[420px] h-[420px] rounded-full bg-saffron/10 blur-3xl" />
    <div className="absolute left-1/3 bottom-0 w-[280px] h-[280px] rounded-full bg-indiagreen/10 blur-3xl" />
    <img src={LOGO_URL} alt="" className="absolute right-8 top-24 w-24 opacity-20 hidden lg:block" />
    <div className="relative max-w-5xl mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="font-mono text-xs uppercase tracking-[0.25em] text-saffron mb-6"
      >
        {kicker}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6"
      >
        {title}
      </motion.h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-base sm:text-lg text-white/70 max-w-2xl leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
